<tui-scrollbar>
  <router-outlet></router-outlet>
</tui-scrollbar>
